export const InstallmentsContainer = ({ installmentsQuantity, children }) => (
  <div className="border-top py-4">
    <h1 className="fw-light">
      Boletos do pedido
      {installmentsQuantity ? <span> ({installmentsQuantity})</span> : null}
    </h1>

    {children}
  </div>
);
